import React from "react";

const Services = () => {
  return (
    <div className="services">
      <div className="top-title">
        <h3>
          Design and execute complex <br /> technical projects
        </h3>
      </div>
      <div className="row g-3">
        <div className="col-lg-4 col-xl-3 col-md-6 col-12">
          <div className="card">
            <h3>Professionally designed</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore
              velit alias quasi dolor facilis voluptatibus ipsa harum corporis
              debitis libero, iusto mollitia, odio accusantium saepe aperiam
              facere sapiente! Porro, facilis.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-xl-3 col-md-6 col-12">
          <div className="card">
            <h3>Professionally designed</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore
              velit alias quasi dolor facilis voluptatibus ipsa harum corporis
              debitis libero, iusto mollitia, odio accusantium saepe aperiam
              facere sapiente! Porro, facilis.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-xl-3 col-md-6 col-12">
          <div className="card">
            <h3>Professionally designed</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore
              velit alias quasi dolor facilis voluptatibus ipsa harum corporis
              debitis libero, iusto mollitia, odio accusantium saepe aperiam
              facere sapiente! Porro, facilis.
            </p>
          </div>
        </div>
        <div className="col-lg-4 col-xl-3 col-md-6 col-12">
          <div className="card">
            <h3>Professionally designed</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore
              velit alias quasi dolor facilis voluptatibus ipsa harum corporis
              debitis libero, iusto mollitia, odio accusantium saepe aperiam
              facere sapiente! Porro, facilis.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
